<template>
  <ImageSearch/>
</template>

<script>
import ImageSearch from '../components/imagesearch/dashboard';

export default {
  components: {
    "ImageSearch": ImageSearch,
  },
};
</script>
<style>

</style>
